import { Job, Lead } from '@kanda-libs/ks-frontend-services';

import { getDepositLimit } from 'pages/Quote/helpers';

import { FormattedRates } from '../constants';

export const formatAPRLabel = (apr: string): string => `${apr}%`;

export const APRIsVisible = (
  rates: FormattedRates,
  apr: string,
  job: Job,
  lead?: Lead,
) => {
  const aprRates = rates[apr];

  const validAprRates = aprRates.filter((rate) => {
    const depositLimits = getDepositLimit(rate.name, job, lead);
    const min = parseInt(depositLimits.min, 10);
    const max = parseInt(depositLimits.max, 10);

    return max >= min;
  });

  return validAprRates.length > 0;
};
